









































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { BankCustodian } from "@/admin/types";
import * as elements from "@/shared/elementsUrls";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import * as RouteNames from "@/employee/route-names";
import { LeafHouseDisclosureDocumentKey } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";

@Component({
  computed: {
    LeafHouseDisclosureDocumentKey () {
      return LeafHouseDisclosureDocumentKey;
    }
  },
  components: {
    GenericLoadingSpinner
  }
})
export default class DisclosureLinks extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();
  featureFlags = useFeatureFlagStore();
  wizardStore = useDrivewealthWizardStore();
  signingDocumentStore = useSigningDocumentStore();

  ElementsUrls = elements;
  RouteNames = RouteNames;

  mounted (): void {
    this.signingDocumentStore.getLeafhouseAccountSignatureDocuments({force: true});
  }

  open (url): void {
    openUrl(url, AppBrowserTarget.system);
  }

  get showElementsFeeSchedule (): boolean {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.Elements;
  }

  get equitiesDripDisclosureUrl (): string {
    return "https://legal.drivewealth.com/dividend-reinvestment-program-drip-disclosure";
  }

  get isMobile (): boolean {
    return isMobileApp();
  }

  getDocumentUrl (documentKey): string {
    const url = window.location.protocol + "//" + window.location.host + "/#/" + "document-view" + "?documentKey=" + documentKey;
    return url;
  }

  get isHsab (): boolean {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }
}
